<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Faqs" :submit="submit"
    :status="status" :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/size_spots'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Titulo</div>
                <v-text-field :error-messages="errors" v-model="data.title" label="Titulo" solo hide-details="auto"
                  class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="order" rules="positive|required" v-slot="{ errors }">
                <div class="label-base pb-1">Orden</div>
                <v-text-field :error-messages="errors" v-model="data.order" type="Number" label="Orden" solo
                  hide-details="auto" class="input-base custom-number">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.order++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.order = Math.max(0, data.order - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="length" rules="positive|integer|required" v-slot="{ errors }">
                <div class="label-base pb-1">Longitud</div>
                <v-text-field :error-messages="errors" v-model="data.length" type="Number" label="Longitud" solo
                  hide-details="auto" class="input-base custom-number">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.length++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.length = Math.max(0, data.length - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="width" rules="non_negative|integer|required" v-slot="{ errors }">
                <div class="label-base pb-1">Ancho</div>
                <v-text-field :error-messages="errors" v-model="data.width" type="Number" label="Ancho" solo
                  hide-details="auto" class="input-base custom-number">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.width++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.width = Math.max(0, data.width - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="icon" :rules="required_icon" v-slot="{ validate, errors }">
                <div class="label-base pb-1">Icon</div>
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                  placeholder="Icon" prepend-icon="fas fa-camera" label="" :multiple="false"
                  :onSelectedPicture="onSelectedPicture" :validate=validate></Upload>
                <v-img :src="icon" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from 'vuex';
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from '@/mixins/crud_form';

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, Upload, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Size_spots.status,
    })
  },
  async created() {
    if (this.$route.params.id) this.required_icon = ''
  },
  data() {
    return {
      storeName: 'Size_spots',
      title: "Tamaño de Spot",
      filteredAttributes: ["icon"],
      icon: "",
      data: {
        title: '',
        description: '',
        icon: undefined,
        order: '',
        length: null,
        width: null,
      },
      required_icon: "required",
    }
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.icon = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.icon = fr.result;
      };
      fr.onerror = function () {
        self.icon = '';
      };
      fr.readAsDataURL(this.data.icon);
    }
  },
}
</script>
